import Storage from '../Store/Store'

const GlobalRequest = {
  store: Storage,
  head () {
    let head = {
      'Accept': 'application/json',
      'Content-type': 'application/json',
      'Lang': (window.localStorage.getItem('vue-lang') !== undefined) ? window.localStorage.getItem('vue-lang') : 'ru',
      'timeZoneOffset': -new Date().getTimezoneOffset()
    }

    if (window.localStorage.getItem('auth') !== undefined) {
      head['Auth'] = window.localStorage.getItem('auth')
    }

    return head
  },

  get (url, params, options = {}) {
    let new_url = url
    if (params) {
      new_url = new_url + '?'
      for (let key in params) {
        new_url = new_url + "&" + key + "=" + params[key]
      }
    }
    return this.request('GET', new_url, null, false, options)
  },

  delete (url, params) {
    let new_url = url
    if (params){
      new_url = new_url + '?'
      for (let key in params) {
        new_url = new_url + "&" + key + "=" + params[key]
      }
    }
    return this.request('DELETE', new_url)
  },

  put (url, params) {
    return this.request('PUT', url, params)
  },

  post (url, params) {
    return this.request('POST', url, params)
  },

  sendfile (url, params) {
    return this.request('POST', url, params, true)
  },

  request (method, url, params, file, options = {}) {
    return new Promise(function (resolve, reject) {
      if (this.store.main.state.visibilityState || this.store.ServiceBridgeWS.getters.WsGetStatus) {
        let xhr = new XMLHttpRequest()
        xhr.open(method, this.baseURL + url)

        if (options.responseType) {
          xhr.responseType = options.responseType
        }

        var headers = this.head()

        for (let i in this.headers) {
          headers[i] = this.headers[i]
        }
        Object.assign(headers, options.headers)

        if (file) {
          delete headers['Content-type']
        }

        for (let i in headers) {
          xhr.setRequestHeader(i, headers[i])
        }

        xhr.onload = function () {
          var contentType = xhr.getResponseHeader('content-type') || ''
          var json = contentType.indexOf('application/json') !== -1
          var data = xhr.response
          try {
            if (json && !options.responseType) data = JSON.parse(xhr.response)
          } catch (error) {
            xhr.data = xhr.response
            reject(xhr)
            return
          }

          if (xhr.status === 200 || xhr.status === 202) {
            resolve({
              data: data,
              headers: contentType
            })
          } else {
            xhr.data = data
            reject(xhr)
          }
        }

        xhr.onerror = reject
        xhr.send(params)
      }
    }.bind(this))
  },

  addHeader (headers) {
    for (let i in headers) {
      this.headers[i] = headers[i]
    }
  }

}

export default GlobalRequest
